define("ROOM4.CCAProductImageEventOverlay.EntryPoint", [
  "ROOM4.CCAProductImageEventOverlay.CCAProductImageEventOverlay.View",
  "ROOM4.CCAProductImageEventOverlay.CCAProductImageEventOverlay.Details.View",
  "ROOM4.CCAProductImageEventOverlay.CCAItemClearanceImageOverlay.View",
  "ROOM4.CCAProductImageEventOverlay.CCAProductClearanceBanner.View",
  "ROOM4.CCAProductImageEventOverlay.CCAProductClearancePriceLabel.View",
], function (
  CCAProductImageEventOverlayView,
  CCAProductImageEventOverlayDetailsView,
  CCAItemClearanceImageOverlayView,
  CCAProductClearanceBannerView,
  CCAProductClearancePriceLabelView,
) {
  "use strict";

  function getBannerConfigTimezone(container) {
    var env = container.getComponent("Environment");
    var timezone = env.getConfig("CCAProductImageEventOverlay.timezone");
    return timezone;
  }

  return {
    mountToApp: function mountToApp(container) {
      var PLP = container.getComponent("PLP");
      if (PLP) {
        PLP.addChildViews(PLP.PLP_VIEW, {
          CCAItemImageOverlay: {
            "CCAItemImageOverlay.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAProductImageEventOverlayView({
                  timezone: getBannerConfigTimezone(container),
                });
              },
            },
          },
        });
        PLP.addChildViews(PLP.PLP_VIEW, {
          CCAItemClearanceImageOverlay: {
            "CCAItemClearanceImageOverlay.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAItemClearanceImageOverlayView({});
              },
            },
          },
        });
      }

      var PDP = container.getComponent("PDP");
      if (PDP) {
        PDP.addChildViews(PDP.PDP_FULL_VIEW, {
          CCAItemDetailsImageOverlay: {
            "CCAItemDetailsImageOverlay.Details.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAProductImageEventOverlayDetailsView({
                  timezone: getBannerConfigTimezone(container),
                });
              },
            },
          },
        });
        PDP.addChildViews(PDP.PDP_FULL_VIEW, {
          "Product.Clearance": {
            "Product.Clearance.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAProductClearanceBannerView({});
              },
            },
          },
        });
        PDP.addChildViews(PDP.PDP_FULL_VIEW, {
          "Product.ClearancePrice": {
            "Product.ClearancePrice.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAProductClearancePriceLabelView({});
              },
            },
          },
        });
        PDP.addChildViews(PDP.PDP_QUICK_VIEW, {
          CCAItemDetailsImageOverlay: {
            "CCAItemDetailsImageOverlay.Details.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAProductImageEventOverlayDetailsView({
                  timezone: getBannerConfigTimezone(container),
                });
              },
            },
          },
        });
        PDP.addChildViews(PDP.PDP_QUICK_VIEW, {
          "Product.Clearance": {
            "Product.Clearance.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAProductClearanceBannerView({});
              },
            },
          },
        });
        PDP.addChildViews(PDP.PDP_QUICK_VIEW, {
          "Product.ClearancePrice": {
            "Product.ClearancePrice.View": {
              childViewIndex: 0,
              childViewConstructor: function () {
                return new CCAProductClearancePriceLabelView({});
              },
            },
          },
        });
      }
    },
  };
});
